import { createProperties, type Field, type TypeToFields } from '@jmvdevelop/svelte-form';
import * as z from 'zod';
import {
    zCareerStatusEnum,
    zEducationLevelEnum,
    zExperienceLevelEnum,
    zSearchHeaderFormData_FreelancerEnum,
    zSearchHeaderFormData_ProfileContentEnum,
} from '$gql/zod-generated';

export const zProsFiltersData = z.object({
    jobSituations: z.array(zCareerStatusEnum),
    educationLevels: z.array(zEducationLevelEnum),
    category: z.number().nullable(),
    profileContents: z.array(zSearchHeaderFormData_ProfileContentEnum),
    freelancer: zSearchHeaderFormData_FreelancerEnum,
    experienceBuckets: z.array(zExperienceLevelEnum),
});

export type ProFiltersData = z.infer<typeof zProsFiltersData>;
type FormData = ProFiltersData;

export type Fields<TFormValues> = TypeToFields<TFormValues, FormData>;

export const empty: FormData = {
    jobSituations: [],
    educationLevels: [],
    category: null,
    profileContents: [],
    freelancer: 'all',
    experienceBuckets: [],
};

export function createFields<TValues>(self: Field<TValues, FormData>): Fields<TValues> {
    return {
        self: self,
        ...createProperties(self, [
            'jobSituations',
            'educationLevels',
            'profileContents',
            'category',
            'freelancer',
            'experienceBuckets',
        ] as const),
    };
}
